/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChatTypeEnum } from './chatTypeEnum';


export interface ChatEventChatCreatedContentDto { 
    /**
     * id чата, в котором событие
     */
    chatId: string;
    /**
     * наименование чата (или скорее темы)
     */
    chatName: string;
    chatType: ChatTypeEnum;
    /**
     * новое описание чата
     */
    chatDescription?: string | null;
}
export namespace ChatEventChatCreatedContentDto {
}


